var _rect, _text, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Berlin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#7f1d1d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 44,
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#ffffff"
  }, "b")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 44,
    r: 8,
    fill: "#f07167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementIcon);
export default __webpack_public_path__ + "static/media/element-icon.b208d62d768e4c13b302bbca8dca83b3.svg";
export { ForwardRef as ReactComponent };